<template>
    <el-col :xs="24" :md="12" :cols="12">
        <div id="colderecha">
            <template v-if="paso == 1">
                <h2>Expiración y consentimiento</h2>
            </template>
            <ul class="actionList">
                <li @click="addexpdate = true;" :class="['tipodocumento', { 'active': addexpdate }]">
                    <div style="display:flex; align-items: center;">
                        <div class="icono">
                            <img src="@/assets/fecha-limite.png" width="70%" />
                        </div>
                        <p style="margin:0px;">Añadir fecha de expiración</p>
                    </div>
                </li>
                <el-collapse-transition>
                    <div style="margin: 10px 0px; width: 100%" v-show="addexpdate">
                        <el-date-picker style="width: 100%" size="large" v-model="configEnvio.fechaExp" type="datetime"
                            placeholder="Selecciona fecha y hora" format="DD/MM/YYYY HH:mm:ss" />
                    </div>
                </el-collapse-transition>
                <li @click="addexpdate = false; configEnvio.fechaExp = null"
                    :class="['tipodocumento', { 'active': !addexpdate }]">
                    <div style="display:flex; align-items: center;">
                        <div class="icono">
                            <img src="@/assets/infinito.png" width="70%" />
                        </div>
                        <p style="margin:0px;">El documento no expira</p>
                    </div>
                </li>
                <el-switch v-model="configEnvio.consentimiento" size="large" active-text="Requerir consentimiento para leer el documento" />
            </ul>
            <div style="display:flex;">
                <el-button type="primary" icon="Back" @click="$router.go(-1)" :disabled="leftDisabled" />
                <el-button type="primary" icon="Right" :disabled="rightDisabled" @click="$router.push('/confirm')" />
            </div>
        </div>
    </el-col>
</template>

<script>
// import { ElNotification } from 'element-plus';
// import { curl } from '@/api.js';
import { mapMutations } from 'vuex'
import { mapState } from 'vuex'
export default {
    name: 'SelectorCaducidad',
    watch: {
    },
    data() {
        return {
            loading: false,
            paso: 1,
            tipoDocumento: '',
            acciones: {},
            addexpdate: false,
        }
    },
    mounted() {
    },
    computed: {
        ...mapState([
            'datosemp', 'receptores', 'configEnvio', 'files'
        ]),
        leftDisabled() {
            return false;
        },
        rightDisabled() {
            if (!this.configEnvio.fechaExp && this.addexpdate) {
                return true;
            }
            return false;
        }
    },
    methods: {
        ...mapMutations([
            'setDatosemp',
            'setReceptores'
        ]),
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#colderecha {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-height: calc(100vh - 20px);
    overflow: auto;
    padding: 10px 0px;

    @media(max-width: 400px) {
        height: 80vh;
    }

    .actionList {
        list-style: none;
        min-width: 50%;
        padding: 0px;

        .tipodocumento {
            display: flex;
            flex-direction: column;
            cursor: pointer;
            padding: 10px;
            border: 2px solid #a9a9a929;
            margin-bottom: 10px;
            border-radius: 10px;
            font-weight: bold;
            transition: 0.5s;
            justify-content: flex-start;

            &:hover {
                background-color: #a9a9a929;
                border-color: #a9a9a929;
            }

            &.active {
                background-color: rgba(9, 133, 227, 0.253);
                border-color: rgba(9, 133, 227, 0.466);
            }

            .icono {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 50px;
                height: 50px;
                background: #0985e325;
                border-radius: 10px;
                margin-right: 10px;
            }
        }
    }
}
</style>